import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Button, Form, Modal } from "react-bootstrap";
import { ITotalProps } from "./ITotalProps";
import { IReceipt } from "../../../types/IReceipt";
import { createOrder } from "../../../services/Service";
import { IReceiptData } from "../../../types/IReceiptData";
import "./style.css";
import { generateGUID, GenerateGUID } from "../../../helpers/Helper";
import { Message, MessageHeader } from "semantic-ui-react";
import { IPrinter } from "../../../types/IPrinter";
import { CardModal, ICardModalProps } from "../../modals/CardModal";

export const TotalModal: React.FC<ITotalProps> = (
  props: ITotalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [toPayAmount, setToPayAmount] = React.useState("");
  const [payValue, setPayValue] = React.useState("");
  const [toPayType, setToPayType] = React.useState("Amount Due");
  const [payRemaining, setPayRemaining] = React.useState("");

  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);

  const [showCardModal, setShowCardModal] = React.useState(false);
  const [printerOptions, setPrinterOptions] = React.useState(false);

  const [transactionId, setTransactionId] = React.useState("");

  const buttonStyle = {
    width: "15vh",
    height: "10vh",
    fontSize: "4vh",
    fontWeight: "bolder",
    maxWidth: "100px",
    maxHeight: "100px",
    padding: 0,
  };

  function appendChar(value: string) {
    let v = payValue;
    v = v + value;
    setPayValue(v);
  }

  function deleteLastChar() {
    const v = payValue;
    const newValue = v.substring(0, v.length - 1);
    setPayValue(newValue);
  }

  function updatePricing() {
    setToPayType("Amount Due");

    const enteredValue = payValue;
    const value = parseFloat(enteredValue);
    const total = parseFloat(toPayAmount);

    if (isNaN(value)) {
      setToPayType("Amount Due");
      setPayRemaining(getTotal().toFixed(2));
      return;
    }

    if (value < total) {
      const remainingValue = total - value;
      setPayRemaining(remainingValue.toFixed(2));
      return;
    }

    setToPayType("Change");
    const change = total - value;
    setPayRemaining((change * -1).toFixed(2));
  }

  useEffect(() => {
    updatePricing();
    setToPayAmount(props.toPayAmount);
    setTransactionId(generateGUID());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payValue, props.toPayAmount]);

  const changeInGreen = () => (
    <>
      <div style={{ color: "green" }}>£{payRemaining}</div>
    </>
  );

  const dueInRed = () => (
    <>
      <div style={{ color: "red" }}>£{payRemaining}</div>
    </>
  );

  const errorMessage = () => (
    <>
      <Message negative>
        <MessageHeader>Saving receipt failed</MessageHeader>
        <p>
          Please check your network (internet). If the error persist please
          contact support
        </p>
      </Message>
    </>
  );

  const paymentScreen = () => (
    <>
      <>
        {error ? errorMessage() : <></>}
        <div
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div>
            <table>
              <tr>
                <td
                  style={{
                    width: 150,
                    backgroundColor: "whitesmoke",
                    verticalAlign: "top",
                    padding: 10,
                  }}
                >
                  {toPayType}:
                  <h1>
                    {toPayType === "Change" ? changeInGreen() : dueInRed()}
                  </h1>
                </td>
                <td style={{ width: 5, backgroundColor: "white" }}></td>
                <td>
                  <table>
                    <tr>
                      <td colSpan={4} style={{ backgroundColor: "" }}>
                        <Form.Control
                          placeholder="£"
                          aria-label="£"
                          aria-describedby="basic-addon1"
                          style={{
                            fontSize: "25px",
                            width: "40vw",
                            maxWidth: "400px",
                          }}
                          value={"£" + payValue}
                          onChange={() => updatePricing()}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("7")}
                        >
                          7
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("8")}
                        >
                          8
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("9")}
                        >
                          9
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("5.00")}
                        >
                          £5
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("4")}
                        >
                          4
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("5")}
                        >
                          5
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("6")}
                        >
                          6
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("10.00")}
                        >
                          £10
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("1")}
                        >
                          1
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("2")}
                        >
                          2
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("3")}
                        >
                          3
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("20.00")}
                        >
                          £20
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("0")}
                        >
                          0
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar(".")}
                        >
                          .
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => deleteLastChar()}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            fill="currentColor"
                            className="bi bi-backspace"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.83 5.146a.5.5 0 0 0 0 .708L7.975 8l-2.147 2.146a.5.5 0 0 0 .707.708l2.147-2.147 2.146 2.147a.5.5 0 0 0 .707-.708L9.39 8l2.146-2.146a.5.5 0 0 0-.707-.708L8.683 7.293 6.536 5.146a.5.5 0 0 0-.707 0z" />
                            <path d="M13.683 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7.08a2 2 0 0 1-1.519-.698L.241 8.65a1 1 0 0 1 0-1.302L5.084 1.7A2 2 0 0 1 6.603 1zm-7.08 1a1 1 0 0 0-.76.35L1 8l4.844 5.65a1 1 0 0 0 .759.35h7.08a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                          </svg>
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue(props.toPayAmount)}
                        >
                          £{props.toPayAmount}
                        </Button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Total £{toPayAmount}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{paymentScreen()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="info"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => setPayValue("")}
              >
                Clear
              </Button>
            </div>
            <Button
              variant="danger"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => {
                props.close();
                setSaving(false);
                setError(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="warning"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => setShowCardModal(true)}
            >
              Card
            </Button>
            <Button
              variant="info"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => setShowCardModal(true)}
              disabled={true}
            >
              Online
            </Button>

            <Button
              variant="success"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => completeOrder()}
              disabled={saving}
            >
              Complete
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  // function onPrinterClick(p: IPrinter) {
  //   processComplete([p]);
  //
  // }

  function onPrinterClick(printer: IPrinter) {
    const printerOptions = printer.name.split(":");

    let printers: IPrinter[] = [];

    const availablePrinters = context.Configuration.getSettings().printers;

    printerOptions.forEach((additionalPrinter) => {
      availablePrinters.forEach((p) => {
        const pValues = p.name.split(":");
        if (pValues[0] === additionalPrinter) {
          printers.push(p);
        }
      });
    });

    processComplete(printers);
    setPrinterOptions(false);
  }

  function onAllPrinterClick() {
    processComplete(context.Configuration.getSettings().printers);
    setPrinterOptions(false);
  }

  function onNonePrinterClick() {
    processComplete([]);
    setPrinterOptions(false);
    props.showTransactionTypes();
    setPayValue("");
    setSaving(false);
    setError(false);
    context.Receipt.clear();
  }

  function printerName(printer: IPrinter) {
    const values = printer.name.split(":");
    return values[0];
  }

  const printOptionsModal = (): JSX.Element => {
    return (
      <>
        <Modal
          show={printerOptions}
          onHide={() => setPrinterOptions(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Print ?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ float: "left" }}>
              {context.Configuration.getSettings()
                .printers.sort((a, b) => (a.position > b.position ? 1 : -1))
                .map((p) => (
                  <div style={{ padding: 10, float: "left" }}>
                    <Button
                      variant="primary"
                      style={{
                        width: 150,
                        height: 100,
                        fontWeight: "bolder",
                        borderRadius: "10px",
                        fontSize: 16,
                      }}
                      onClick={() => onPrinterClick(p)}
                      key={p.id}
                    >
                      {printerName(p)}
                    </Button>
                  </div>
                ))}
            </div>

            {context.Configuration.getSettings().printers.length > 1 ? (
              <div style={{ padding: 10, float: "left" }}>
                <Button
                  variant="primary"
                  style={{
                    width: 100,
                    height: 100,
                    fontSize: "16px",
                    fontWeight: "bolder",
                  }}
                  onClick={() => onAllPrinterClick()}
                >
                  All
                </Button>
              </div>
            ) : (
              <></>
            )}

            <div style={{ padding: 10, float: "left" }}>
              <Button
                variant="primary"
                style={{
                  width: 100,
                  height: 100,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => onNonePrinterClick()}
              >
                No print
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <Button
              variant="secondary"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => {
                setPrinterOptions(false);
                setSaving(false);
                setError(false);
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  function getTotal() {
    let total = 0;
    context.Receipt.getRows().forEach((r) => {
      total += r.qty * r.price;
    });
    return total;
  }

  async function completeOrder() {
    const enteredValue = payValue;
    const value = parseFloat(enteredValue);
    const total = parseFloat(toPayAmount);

    setError(false);
    setSaving(true);

    if (isNaN(value)) {
      setSaving(false);
      return;
    }

    if (value < total) {
      setSaving(false);
      return;
    }

    setPrinterOptions(true);

    //const rows = context.Receipt.getRows();
    // const settings = context.Configuration.getSettings();

    // const organisation = settings.organisation;

    // const customer = context.Customer.getCustomer();
    // const user = context.AuthenticatedUser.getUser().fullname;
    // const transactionType = context.Receipt.getTransactionType();
    // const paymentType = context.Receipt.getPaymentType();
    // const receiptNumber = context.Receipt.getReceiptNumber();

    // const table = context.Receipt.getTable();

    // let receipt: IReceipt = {
    //   id: 0,
    //   createdAt: new Date(),
    //   rows: rows,
    //   total: getTotal(),
    //   customerReceiptNumber: receiptNumber,
    //   organisation: organisation,
    //   customer: customer,
    //   transactionType: transactionType,
    //   paymentType: paymentType,
    //   user: user,
    //   endComment: organisation.endComment,
    //   enteredValue: value.toFixed(2),
    //   changeGiven: ((total - value) * -1).toFixed(2),
    //   printerSettings: printers, //[], //settings.printers,
    //   table: table !== undefined ? table.uuid : "",
    // };

    // const receiptData: IReceiptData = {
    //   receipt: receipt,
    //   token: context.AuthenticatedUser.getToken(),
    //   tableUuid: generateGUID(),
    // };

    // var id = await createOrder(
    //   receiptData,
    //   context.AuthenticatedUser.getToken()
    // );

    // if (!id) {
    //   setError(true);
    //   return;
    // }

    // const receiptJson = JSON.stringify(receiptData);
    // var encodedStringBtoA = btoa(receiptJson);

    // let url = "https://print.waepos.com/Default.aspx?id=" + id;
    // url += "&data=" + encodedStringBtoA;

    // window.location.href = url;

    // props.showTransactionTypes();
    // setPayValue("");
    // setSaving(false);
    // setError(false);
    // context.Receipt.clear();
  }

  async function processComplete(printers: IPrinter[]) {
    const enteredValue = payValue;
    const value = parseFloat(enteredValue);
    const total = parseFloat(toPayAmount);
    setError(false);
    setSaving(true);

    if (isNaN(value)) {
      setSaving(false);
      return;
    }

    if (value < total) {
      setSaving(false);
      return;
    }

    const rows = context.Receipt.getRows();
    const settings = context.Configuration.getSettings();

    const organisation = settings.organisation;

    const customer = context.Customer.getCustomer();
    const user = context.AuthenticatedUser.getUser().fullname;
    const transactionType = context.Receipt.getTransactionType();
    const paymentType = context.Receipt.getPaymentType();
    const receiptNumber = context.Receipt.getReceiptNumber();

    const table = context.Receipt.getTable();

    if (table !== undefined) {
      customer.name = table.description1;
    }

    let receipt: IReceipt = {
      id: 0,
      createdAt: new Date(),
      rows: rows,
      total: getTotal(),
      customerReceiptNumber: receiptNumber,
      organisation: organisation,
      customer: customer,
      transactionType: transactionType,
      paymentType: paymentType,
      user: user,
      endComment: organisation.endComment,
      enteredValue: value.toFixed(2),
      changeGiven: ((total - value) * -1).toFixed(2),
      printerSettings: printers, //[], //settings.printers,
      table: table !== undefined ? table.uuid : "",
    };

    const receiptData: IReceiptData = {
      receipt: receipt,
      token: context.AuthenticatedUser.getToken(),
      tableUuid: table !== undefined ? table.uuid : "",
    };

    var id = await createOrder(
      receiptData,
      context.AuthenticatedUser.getToken()
    );

    if (!id) {
      setError(true);
      return;
    }

    if (printers.length > 0) {
      const receiptJson = JSON.stringify(receiptData);
      var encodedStringBtoA = btoa(receiptJson);

      let url = "https://print.waepos.com/Default.aspx?id=" + id;
      url += "&data=" + encodedStringBtoA;

      window.location.href = url;
    }

    props.showTransactionTypes();
    setPayValue("");
    setSaving(false);
    setError(false);
    context.Receipt.clear();
  }

  const cardModalProps: ICardModalProps = {
    close: function (): void {
      setShowCardModal(false);
      //      context.Receipt.setTransactionType("Card");
    },
    show: showCardModal,
    uuid: transactionId,
  };

  return (
    <>
      <>{customerModal()}</>
      <>{printOptionsModal()}</>
      <CardModal {...cardModalProps} />
    </>
  );
};
